import {
  ActionReducerMapBuilder,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  BaseRequirement,
  BaseRequirementsResult,
} from "../interfaces/base-requirements.types.ts";
import {
  addBaseRequirement,
  createBaseRequirement,
  fetchAllBaseRequirements,
  fetchBaseRequirementByID,
  updateBaseRequirementByID,
} from "../actions/baseRequirementsActions.tsx";

export interface BaseRequirementsState extends BaseRequirementsResult {
  loading: boolean;
  activeRequirement: BaseRequirement | null;
}

const initialState = {
  count: 0,
  next: null,
  previous: null,
  results: [],
  loading: false,
  activeRequirement: null,
} satisfies BaseRequirementsState as BaseRequirementsState;

const baseRequirementsSlice = createSlice({
  name: "baseRequirements",
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<BaseRequirementsState>) => {
    builder.addCase(fetchAllBaseRequirements.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      fetchAllBaseRequirements.fulfilled,
      (state, action: PayloadAction<BaseRequirementsResult>) => {
        state.count = action.payload.count;
        state.next = action.payload.next;
        state.previous = action.payload.previous;
        state.results = action.payload.results;
        state.loading = false;
      },
    );

    builder.addCase(fetchBaseRequirementByID.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      fetchBaseRequirementByID.fulfilled,
      (state, action: PayloadAction<BaseRequirement>) => {
        state.loading = false;
        state.activeRequirement = action.payload;
      },
    );

    builder.addCase(fetchBaseRequirementByID.rejected, (state) => {
      state.loading = false;
      state.activeRequirement = null;
    });

    builder.addCase(createBaseRequirement.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      createBaseRequirement.fulfilled,
      (state, action: PayloadAction<BaseRequirement>) => {
        state.loading = false;
        state.results.push(action.payload);
      },
    );

    builder.addCase(createBaseRequirement.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(updateBaseRequirementByID.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      updateBaseRequirementByID.fulfilled,
      (state, action: PayloadAction<BaseRequirement>) => {
        state.loading = false;
        state.activeRequirement = action.payload;
      },
    );

    builder.addCase(updateBaseRequirementByID.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addBaseRequirement.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addBaseRequirement.fulfilled, (state) => {
      state.loading = false;
    });

    builder.addCase(addBaseRequirement.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default baseRequirementsSlice.reducer;
